import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TestService } from '@services/test.service';
import { Subject, Subscription } from 'rxjs';
import { NewSchedulePopupComponent } from './new-schedule-popup/new-schedule-popup.component';
import { Urldialog } from './url-dialog';
import { RoleManagementService } from '@services/role.management.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
export interface testUrlPass {
  testUrl: string;
  schID: any;
}
@Component({
  selector: 'app-tests-schedule',
  templateUrl: './tests-schedule.component.html',
  styleUrls: ['./tests-schedule.component.scss'],
})
export class TestsScheduleComponent
  implements OnInit, OnDestroy {
  itemServiceSubscription$: Subscription | undefined;
  itemFilterServiceSubscription$: Subscription | undefined;
  schduleList: any;
  schedule: MatTableDataSource<any>;
  displayedColumns: string[] = [
    'schedulename',
    'testType',
    'startdate',
    'enddate',
    'status',
    'examineecount',
    'examineeattempted',
    'testurl',
  ];
  //totalRecords: number;
  totalRecords: any;
  searchText: any;
  page: number = 1;
  itemName = '';
  itemDescription = '';
  itemStatus = '';
  isItemDescended = true;
  globalcollectionid: any;
  globalcollectionuuid: any;
  scheduleName = '';
  public config: any = {
    id: 'custom',
    itemsPerPage: 3,
    currentPage: 1,
  };
  testId: any;
  @Input() testuuId: any;
  @Input() testBankId: any;
  @Input() isPublished: any;

  setAddSchedule = false;
  pageOfItems: any;
  currentTestId: any;

  scheduleType = '';
  scheduleStatus = '';
  // scheduleName='';

  fromDate = '';
  toDate = '';
  filtertoDate = '';
  filterfromDate = '';
  isNoItems = false;
  schduletypeSearch = '';
  scheduleTestId: any;
  testIdArray: [];
  testUrl = 'http://tanaydemo.mundrisoftsolutions.com/';
  noDataFound: boolean = false;
  isEditEnabled = false;
  scheduleTypeInp: string;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private unsubscribe: Subject<void> = new Subject<void>();
  schedateDatacount: any;
  constructor(
    private testService: TestService,
    private router: Router,
    private actRoute: ActivatedRoute,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private webErrorService: WebErrorService,
    public roleSer: RoleManagementService,
    public translate: TranslateService
  ) {
    // this.testService.listMode.subscribe(data=>{
    //   if (data) {
    //     this.ngOnInit();
    //   }
    // })
    this.testService.scheduleBackBtnobs.subscribe((ResbackBtn) => {
      this.setAddSchedule = ResbackBtn;
      this.isEditEnabled = ResbackBtn;
      if (!ResbackBtn) {
        this.getTableData();
      }
    });
  }

  ngOnInit(): void {
    this.testId = this.testuuId;
    if (this.testId) {
      this.currentTestId = this.testuuId
    }
    this.globalcollectionid = JSON.parse(
      sessionStorage.getItem('defaultcollectionid')
    );
    this.globalcollectionuuid = JSON.parse(
      sessionStorage.getItem('defaultcollectionuuid')
    );

    if (this.currentTestId) {
      this.itemServiceSubscription$ =
        this.testService
          .getTestSchedule(this.globalcollectionuuid, this.currentTestId)
          ?.subscribe(
            (schedata) => {
              this.schedule = schedata?.data;
              this.schedateDatacount = schedata?.data.length;
              if (schedata?.data.length == 0) {
                this.isNoItems = true;
              } else {
                setTimeout(() => {
                  this.schedule = new MatTableDataSource(schedata?.data);
                  this.schedule.sort = this.sort;
                  this.schedule.paginator = this.paginator;
                  this.translate.stream([
                    'testId.TabSchedules.pagination.pageLabel',
                    'testId.TabSchedules.pagination.firstPage',
                    'testId.TabSchedules.pagination.lastPage',
                    'testId.TabSchedules.pagination.nextPage',
                    'testId.TabSchedules.pagination.prevPage'
                  ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                      this.schedule.paginator._intl.itemsPerPageLabel = translation['testId.TabSchedules.pagination.pageLabel'];
                      this.schedule.paginator._intl.firstPageLabel = translation['testId.TabSchedules.pagination.firstPage'];
                      this.schedule.paginator._intl.lastPageLabel = translation['testId.TabSchedules.pagination.lastPage'];
                      this.schedule.paginator._intl.nextPageLabel = translation['testId.TabSchedules.pagination.nextPage'];
                      this.schedule.paginator._intl.previousPageLabel = translation['testId.TabSchedules.pagination.prevPage'];

                      this.schedule.paginator._intl.changes.next();
                  });
                });

                // this.setPagination(this.schedule.paginator);
                this.isNoItems = false;
                this.noDataFound = false
              }
            },
            (error) => {
              this.router.navigate(['/login']);
              this.webErrorService.handleAPIErrors(error);
            },
            () => {
            }
          ) || undefined;
    }
  }

  // setPagination(data) {
  //   if(data) {
  //     setTimeout(() => {
  //       this.schedule.paginator = this.paginator;
  //       this.translate.stream([
  //         'testId.TabSchedules.pagination.pageLabel',
  //         'testId.TabSchedules.pagination.firstPage',
  //         'testId.TabSchedules.pagination.lastPage',
  //         'testId.TabSchedules.pagination.nextPage',
  //         'testId.TabSchedules.pagination.prevPage'
  //       ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
  //           data._intl.itemsPerPageLabel = translation['testId.TabSchedules.pagination.pageLabel'];
  //           data._intl.firstPageLabel = translation['testId.TabSchedules.pagination.firstPage'];
  //           data._intl.lastPageLabel = translation['testId.TabSchedules.pagination.lastPage'];
  //           data._intl.nextPageLabel = translation['testId.TabSchedules.pagination.nextPage'];
  //           data._intl.previousPageLabel = translation['testId.TabSchedules.pagination.prevPage'];

  //           data._intl.changes.next();
  //       });
  //     });
  //   }
  // }

  getTableData(): void {
    this.testId = sessionStorage.getItem('testuuid');
    this.globalcollectionuuid = JSON.parse(
      sessionStorage.getItem('defaultcollectionuuid')
    );
    if (this.testuuId !== undefined) {
      this.itemServiceSubscription$ =
        this.testService
          .getTestSchedule(this.globalcollectionuuid, this.currentTestId)
          ?.subscribe(
            (schedata) => {
              this.schedule = schedata?.data;
              if (schedata?.data.length == 0) {
                this.isNoItems = true;
                this.schedateDatacount = schedata?.data.length;
              } else {
                this.schedateDatacount = schedata?.data.length;
                this.schedule = new MatTableDataSource(schedata?.data);

                setTimeout(() => {
                  this.schedule.sort = this.sort;
                  this.schedule.paginator = this.paginator;
                  if (this.schedule.paginator != undefined) {
                    this.translate.stream([
                      'testId.TabSchedules.pagination.pageLabel',
                      'testId.TabSchedules.pagination.firstPage',
                      'testId.TabSchedules.pagination.lastPage',
                      'testId.TabSchedules.pagination.nextPage',
                      'testId.TabSchedules.pagination.prevPage'
                    ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                        this.schedule.paginator._intl.itemsPerPageLabel = translation['testId.TabSchedules.pagination.pageLabel'];
                        this.schedule.paginator._intl.firstPageLabel = translation['testId.TabSchedules.pagination.firstPage'];
                        this.schedule.paginator._intl.lastPageLabel = translation['testId.TabSchedules.pagination.lastPage'];
                        this.schedule.paginator._intl.nextPageLabel = translation['testId.TabSchedules.pagination.nextPage'];
                        this.schedule.paginator._intl.previousPageLabel = translation['testId.TabSchedules.pagination.prevPage'];

                        this.schedule.paginator._intl.changes.next();
                    });
                  }
                });

                this.isNoItems = false;
                this.noDataFound = false
              }
            },
            (error) => {
              this.router.navigate(['/login']);
              this.webErrorService.handleAPIErrors(error);
            },
            () => {
            }
          ) || undefined;
    }
  }

  ngOnChanges(): void {
    this.testService.updateTestStatus.subscribe(isTestDisabled => {
      if (isTestDisabled == true || this.isPublished) {
        this.isPublished = isTestDisabled == '' ? this.isPublished : isTestDisabled;
      } else {
        this.isPublished = false;
      }
    });
  }

  newSchedule(): void {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      this.testService.schedulUuid = '';
      this.isNoItems = false;
      this.setAddSchedule = true;

      // const dialogRef = this.dialog.open(ScheduleCreateComponent, {
      //   width: '60%',
      //   data: {
      //     schedule: null,
      //     type: 'add',
      //     isPublished: false
      //   },
      // });
      // dialogRef.afterClosed().subscribe((result) => {
      // });
    };
  }

  closeNewTestSchedule(data: any): void {
    this.setAddSchedule = false;
    this.ngOnInit();
  }

  newSchedulePOPUP() {
    const dialogRef = this.dialog.open(NewSchedulePopupComponent, {
      panelClass: 'dialog-container-custom',
      data: {
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {

      }

      else {

      }
    });
  }
  statusChange(value) {
    alert(value);
  }

  filterSchedule(): void {
    this.filterfromDate = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    if (this.filterfromDate == null) {
      this.filterfromDate = '';
    }

    this.filtertoDate = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
    if (this.filtertoDate == null) {
      this.filtertoDate = '';
    }
    if (this.scheduleType) {
      this.schduletypeSearch = this.scheduleType;
    }

    const filterObj = {
      scheduleType: this.scheduleType,
      scheduleStatus: this.scheduleStatus,
      scheduleName: this.scheduleName,
      fromDate: this.filterfromDate,
      todate: this.filtertoDate,
    };

      this.itemFilterServiceSubscription$ =
        this.testService
          .scheduleFilter(this.globalcollectionuuid, this.currentTestId, filterObj)
          ?.subscribe(
            (schedata) => {
              this.schedule = schedata?.data;



              if (schedata?.data == 0) {
                this.noDataFound = true;
                // this.schedule.paginator = 0;
              }
              this.schedule = new MatTableDataSource(schedata?.data);
              this.schedule.sort = this.sort;
              this.schedule.paginator = this.paginator;

              /*  this.schduleList = new MatTableDataSource(this.schedule);
                this.schduleList.sort = this.sort;
                this.schduleList.paginator = this.paginator;*/
              // this.items = new MatTableDataSource(this.items);
              // this.items.sort = this.sort;
              // this.items.paginator = this.paginator;
            },
            (error) => {
              this.router.navigate(['/login']);
              this.webErrorService.handleAPIErrors(error);
            },
            () => {
            }
          ) || undefined;
      this.noDataFound = false;

  }
  // onChangePage(pageOfItems: Array<any>) {
  //   this.totalRecords = this.items.length;
  // }

  // dateSort(): void {
  //   this.isItemDescended = !this.isItemDescended;
  //   this.items.sort(this.sortdate);
  // }

  sortdate(a: any, b: any) {
    //return new Date(a.updated).getTime() - new Date(b.updated).getTime();
    //return new Date(a.updated).getTime() - new Date(b.updated).getTime() ;
    return b.updated > a.updated;
  }

  resetFilter() {
    this.scheduleType = '';
    this.scheduleStatus = '';
    this.scheduleName = '';

    this.fromDate = '';
    this.toDate = '';
    this.filtertoDate = '';
    this.filterfromDate = '';

    this.schduletypeSearch = '';
    this.itemServiceSubscription$ =
      this.testService
        .getTestSchedule(this.globalcollectionuuid, this.currentTestId)
        .subscribe(
          (schedata) => {
            this.schedule = schedata?.data;
            this.schedule = new MatTableDataSource(schedata?.data);
            this.schedule.sort = this.sort;
            this.schedule.paginator = this.paginator;
            /* this.schduleList = new MatTableDataSource(this.schedule);
             this.schduleList.sort = this.sort;
             this.schduleList.paginator = this.paginator;*/
          },
          (error) => {
            this.router.navigate(['/login']);
            this.webErrorService.handleAPIErrors(error);
          },
          () => {
          }
        ) || undefined;
    this.noDataFound = false;
  }

  navigateToScheduleDetails(row) {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      // this.router.navigate(['/collections',this.globalcollectionid, 'scheduledetails',id]);
      // this.setAddSchedule = true;
      // this.testService.schedulUuid = id;
      this.setAddSchedule = false;
      this.isEditEnabled = true;
      const scheduleInfo = {
        scheduleuuId: row?.scheduleuuId,
        testScheduleId: row?.testScheduleId,
        scheduleType: row?.scheduleType,
        scheduleStatus: row?.scheduleStatus
      }
      sessionStorage.setItem('scheduleInfo', JSON.stringify(scheduleInfo));
    };
  }

  openTestUrlDialog(testUrl: string) {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      // localStorage.setItem('scheduleTestId',scheduleTestId)

      const dialogRef = this.dialog.open(Urldialog, {
        width: '60%',
        data: {
          testUrl: testUrl,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
      });
    };
  }

  ngOnDestroy() {
    if (this.itemServiceSubscription$) {
      this.itemServiceSubscription$.unsubscribe();
    }
    if (this.itemFilterServiceSubscription$) {
      this.itemFilterServiceSubscription$.unsubscribe();
    }
    this.isPublished = null;
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
